import React, { useEffect, useState } from "react";
// import BGSlogo from "./Images/BGSlogo.jpg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import BGS from "./Images/logo_page.jpg";
import dayjs from "dayjs";
import { DatePicker } from "antd";

import TermsAndConditions from "./datas/Terms-and-conditions";
import MinorDeclaration from "./datas/MinorDeclaration";
import ApplicantDeclaration from "./datas/ApplicantDeclaration";
export const Membership = () => {
  const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);
  const [isMinorDeclarationChecked, setIsMinorDeclarationChecked] =
    useState(false);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [isMinorTermsAccepted, setIsMinorTermsAccepted] = useState(false);
  const [isApplicantTermsAccepted, setIsApplicantTermsAccepted] =
    useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showMinor, setShowMinor] = useState(false);
  const [showApplicant, setShowApplicant] = useState(false);
  const [dob, setDob] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      (isDeclarationChecked || isMinorDeclarationChecked) &&
      isTermsChecked &&
      (isTermsAccepted || isMinorTermsAccepted || isApplicantTermsAccepted)
    ) {
    } else {
      toast.error(
        "Please agree to either the Declaration by Applicant or Minor Declaration, and the Terms and Conditions."
      );
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const maxSizeInBytes = 1 * 1024 * 1024;

    if (file && file.size > maxSizeInBytes) {
      toast.error("The file size should not exceed 1MB.");
      event.target.value = "";
    }
  };

  const toggleShowTerms = () => setShowTerms(!showTerms);
  const toggleShowMinor = () => setShowMinor(!showMinor);
  const toggleShowApplicant = () => setShowApplicant(!showApplicant);

  const TermsAccepted = (isChecked) => {
    setIsTermsChecked(isChecked);
    setIsTermsAccepted(isChecked);
  };

  const MinorAccepted = (isChecked) => {
    setIsMinorDeclarationChecked(isChecked);
    setIsMinorTermsAccepted(isChecked);
  };

  const ApplicantAccepted = (isChecked) => {
    setIsDeclarationChecked(isChecked);
    setIsApplicantTermsAccepted(isChecked);
  };
  useEffect(() => {
    setIsTermsChecked(isTermsAccepted);
    setIsMinorDeclarationChecked(isMinorTermsAccepted);
    setIsDeclarationChecked(isApplicantTermsAccepted);
  }, [isTermsAccepted, isMinorTermsAccepted, isApplicantTermsAccepted]);

  useEffect(() => {
    setIsTermsAccepted(isTermsChecked);
    setIsMinorTermsAccepted(isMinorDeclarationChecked);
    setIsApplicantTermsAccepted(isDeclarationChecked);
  }, [isTermsChecked, isMinorDeclarationChecked, isDeclarationChecked]);

  return (
    <body className="bg-zinc-100 p-4 font-sans">
      <ToastContainer />
      <div className="max-w-4xl mx-auto bg-white p-8 shadow-lg border border-4 border-blue-400">
        <header className="mb-8 membership">
          <div className="grid grid-cols-2 gap-4 w-full">
            <div className="text-left">
              <img src={BGS} alt="Logo" className="mb-4 w-32 h-auto" />
            </div>
            <div>
              <div className="text-left">
                <h1 className="text-3xl font-bold mb-2">URBAN NIDHI LIMITED</h1>
                <h2 className="font-bold mb-2">
                  Reg. No.: CIN
                  <span className="font-normal text-sm">
                    {" "}
                    U64990PN2023PLN218759
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </header>

        <div className="grid grid-cols-2 gap-4">
          <div className="text-left">
            <p className="font-bold mb-2">
              Regd. Office:{" "}
              <span className="font-normal text-sm">
                Sr. No. 75, Shop No.26, G Wing, Wonder City,
                <br />
                Near Katraj Chowk, Katraj, Pune - 411 046.
              </span>
            </p>
            <p className="font-bold mb-2 ">
              Email:{" "}
              <span className="font-normal text-sm">
                <a href="mailto:bgsarb@gmail.com">
                  bgsarbannidhi2023@gmail.com
                </a>
              </span>
            </p>
          </div>
          <div>
            <div className="text-left">
              <p className="font-bold mb-2">
                Website:{" "}
                <span className="font-normal text-sm">
                  <a href="http://www.bgsnidhi.com">www.bgsnidhi.com</a>
                </span>
              </p>

              <p className="font-bold mb-2">
                Helpline No:{" "}
                <span className="font-normal text-sm">
                  +91 940 5555 855, 8668 777 355
                </span>
              </p>
            </div>
          </div>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="bg-blue-400 py-2 mt-4 mx-[-2rem] text-center">
            <h1 className="text-xl text-white font-bold">
              ACCOUNT OPENING FORM
            </h1>
          </div>
          <div>
            <label className="block mb-1 font-semibold text-left">
              Please open my/our:
            </label>
            <div className="flex items-center">
              <input
                type="radio"
                id="savings"
                name="account_type"
                value="savings"
                className="mr-2"
              />
              <label htmlFor="savings" className="mr-4">
                Savings Account
              </label>
              <input
                type="radio"
                id="daily_pigmy"
                name="account_type"
                value="daily_pigmy"
                className="mr-2"
              />
              <label htmlFor="daily_pigmy" className="mr-4">
                Daily Pigmy A/C
              </label>
              <input
                type="radio"
                id="recurring_deposit"
                name="account_type"
                value="recurring_deposit"
                className="mr-2"
              />
              <label htmlFor="recurring_deposit" className="mr-4">
                Recurring Deposit
              </label>
              <input
                type="radio"
                id="fixed_deposit"
                name="account_type"
                value="fixed_deposit"
                className="mr-2"
              />
              <label htmlFor="fixed_deposit" className="mr-4">
                Fixed Deposit
              </label>

              <input
                type="radio"
                id="mis"
                name="account_type"
                value="mis"
                className="mr-2"
              />
              <label htmlFor="mis" className="mr-4">
                M.I.S
              </label>
            </div>
          </div>

          <div>
            <label className="block mb-1 font-semibold text-left">
              With Opening Amount: INR:
            </label>

            <div className="flex items-center">
              <input type="radio" id="cash" className="mr-2" />
              <label htmlFor="cash" className="mr-4">
                Cash
              </label>
              <input type="radio" id="cheque" className="mr-2" />
              <label htmlFor="cheque" className="mr-4">
                Cheque/DD
              </label>
              <input type="radio" id="online" className="mr-2" />
              <label htmlFor="online" className="mr-4">
                Online Payment
              </label>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="membership-intro"
                className="block mb-1 font-semibold text-left"
              >
                Name of the Applicant:
              </label>
              <input
                type="text"
                id="membership-intro"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="membership-add"
                className="block mb-1 font-semibold text-left"
              >
                Address:
              </label>
              <input
                type="text"
                id="membership-add"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="mobile-no"
                className="block mb-1 font-semibold text-left"
              >
                Mobile No.:
              </label>
              <input
                type="text"
                id="mobile-no"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="establish"
                className="block mb-1 font-semibold text-left"
              >
                Date of Birth:
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    size="small"
                    value={dob}
                    onChange={(newValue) => setDob(newValue)}
                    className="rounded-none border-zinc-300  w-full p-2.5"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>

            <div>
              <label
                htmlFor="aadhar"
                className="block mb-1 font-semibold text-left"
              >
                Aadhaar No.:
              </label>
              <input
                type="text"
                id="aadhar"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="pan"
                className="block mb-1 font-semibold text-left"
              >
                PAN No.:
              </label>
              <input
                type="text"
                id="pan"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="father-name"
                className="block mb-1 font-semibold text-left"
              >
                Father's/Husband's Name:
              </label>
              <input
                type="text"
                id="father-name"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="mother-name"
                className="block mb-1 font-semibold text-left"
              >
                Mother's Name:
              </label>
              <input
                type="text"
                id="mother-name"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="gender"
                className="block mb-1 font-semibold text-left"
              >
                Gender:
              </label>
              <select
                id="gender"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              >
                <option value="" disabled selected>
                  ---Select---
                </option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
                <option value="prefer_not_to_say">Prefer not to say</option>
              </select>
            </div>

            <div>
              <label
                htmlFor="email"
                className="block mb-1 font-semibold text-left"
              >
                E-mail ID:
              </label>
              <input
                type="text"
                id="email"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="altnum"
                className="block mb-1 font-semibold text-left"
              >
                Alternate Number:
              </label>
              <input
                type="text"
                id="altnum"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="city"
                className="block mb-1 font-semibold text-left"
              >
                City:
              </label>
              <input
                type="text"
                id="city"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="occupation"
                className="block mb-1 font-semibold text-left"
              >
                Occupation:
              </label>
              <input
                type="text"
                id="occupation"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="state"
                className="block mb-1 font-semibold text-left"
              >
                State:
              </label>
              <input
                type="text"
                id="state"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="pin"
                className="block mb-1 font-semibold text-left"
              >
                Pin Code:
              </label>
              <input
                type="text"
                id="pin"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="dist"
                className="block mb-1 font-semibold text-left"
              >
                Dist:
              </label>
              <input
                type="text"
                id="dist"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
          </div>

          <div className="bg-blue-400 py-2 mt-4 mx-[-2rem] text-center">
            <h1 className="text-xl font-bold uppercase text-white">
              Service & Business Details
            </h1>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="business-name"
                className="block mb-1 font-semibold text-left"
              >
                Business Name:
              </label>
              <input
                type="text"
                id="business-name"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="business-add"
                className="block mb-1 font-semibold text-left"
              >
                Business Address:
              </label>
              <input
                type="text"
                id="business-add"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="owner"
                className="block mb-1 font-semibold text-left"
              >
                Owner Name:
              </label>
              <input
                type="text"
                id="owner"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="reg-no"
                className="block mb-1 font-semibold text-left"
              >
                Shop act/ Udyam:
              </label>
              <input
                type="text"
                id="reg-no"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="business-mobile-no"
                className="block mb-1 font-semibold text-left"
              >
                Mobile No.:
              </label>
              <input
                type="text"
                id="business-mobile-no"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
            <div>
              <label
                htmlFor="establish"
                className="block mb-1 font-semibold text-left"
              >
                Establishment Date:
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    size="small"
                    value={dob}
                    onChange={(newValue) => setDob(newValue)}
                    className="rounded-none border-zinc-300  w-full p-2.5"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
            <div>
              <label
                htmlFor="business-pan"
                className="block mb-1 font-semibold text-left"
              >
                Business PAN:
              </label>
              <input
                type="text"
                id="business-pan"
                className="border border-zinc-300 p-2 w-full focus:border-blue-500 outline-none"
              />
            </div>
          </div>
          <div className="!mt-6">
            <label
              htmlFor="image-upload"
              className="block mb-1 font-semibold text-left"
            >
              Upload Your Photo
            </label>
            <input
              type="file"
              id="image-upload"
              accept="image/*"
              className="w-full border border-zinc-300 p-2"
              onChange={handleFileChange}
            />
          </div>

          <div className="!mt-6">
            <label
              htmlFor="pan-upload"
              className="block mb-1 font-semibold text-left"
            >
              Upload PAN
            </label>
            <input
              type="file"
              id="pan-upload"
              accept="image/*"
              className="w-full border border-zinc-300 p-2"
              onChange={handleFileChange}
            />
          </div>

          <div>
            <label
              htmlFor="signature-upload"
              className="block mb-1 font-semibold text-left"
            >
              Upload Your Signature
            </label>
            <input
              type="file"
              id="signature-upload"
              accept="image/*"
              className="w-full border border-zinc-300 p-2"
              onChange={handleFileChange}
            />
          </div>
          <div className="flex items-center mt-4">
            <input
              type="checkbox"
              id="declaration"
              checked={isDeclarationChecked}
              onChange={(e) => setIsDeclarationChecked(e.target.checked)}
              className="mr-2"
            />
            <button
              htmlFor="declaration"
              type="button"
              className="ml-2 font-bold text-blue-500 underline"
              onClick={toggleShowApplicant}
            >
              {showApplicant
                ? "Hide Declaration by Applicant"
                : "Declaration by Applicant"}
            </button>
          </div>
          <div className="flex items-center mt-4">
            <input
              type="checkbox"
              id="minor-declaration"
              checked={isMinorDeclarationChecked}
              onChange={(e) => setIsMinorDeclarationChecked(e.target.checked)}
              className="mr-2"
            />
            <button
              type="button"
              htmlFor="minor-declaration"
              className="ml-2 font-bold text-blue-500 underline"
              onClick={toggleShowMinor}
            >
              {showMinor ? "Hide Minor Declaration" : "Minor Declaration"}
            </button>
          </div>
          <div className="flex items-center mt-4">
            <input
              type="checkbox"
              id="terms"
              checked={isTermsChecked}
              onChange={(e) => setIsTermsChecked(e.target.checked)}
              className="mr-2"
            />
            <button
              type="button"
              htmlFor="terms"
              onClick={toggleShowTerms}
              className="ml-2 font-bold text-blue-500 underline"
            >
              {showTerms ? "Hide Terms and Conditions" : "Terms and Conditions"}
            </button>
          </div>

          {showTerms && (
            <div className="mt-4 p-4 border border-gray-300 bg-gray-50">
              <p className="font-semibold">Terms and Conditions</p>
              <p className="text-sm mt-2">
                Please read the terms and conditions carefully...
              </p>
              <div className="text-left mt-4 text-xs">
                <TermsAndConditions />
              </div>
              <div className="flex items-center mt-4">
                <input
                  type="checkbox"
                  id="terms-accepted"
                  checked={isTermsAccepted}
                  onChange={(e) => TermsAccepted(e.target.checked)}
                  className="mr-2"
                />
                <label htmlFor="terms-accepted" className="font-bold">
                  Accepted
                </label>
              </div>
            </div>
          )}

          {showMinor && (
            <div className="mt-4 p-4 border border-gray-300 bg-gray-50">
              <p className="font-semibold">Minor Declaration</p>
              <p className="text-sm mt-2">
                Please read the minor declaration carefully...
              </p>
              <div className="text-left mt-4 text-xs">
                <MinorDeclaration />
              </div>
              <div className="flex items-center mt-4">
                <input
                  type="checkbox"
                  id="terms-accepted"
                  checked={isMinorTermsAccepted}
                  onChange={(e) => MinorAccepted(e.target.checked)}
                  className="mr-2"
                />
                <label htmlFor="terms-accepted" className="font-bold">
                  Accepted
                </label>
              </div>
            </div>
          )}

          {showApplicant && (
            <div className="mt-4 p-4 border border-gray-300 bg-gray-50">
              <p className="font-semibold">Applicant Declaration</p>
              <p className="text-sm mt-2">
                Please read the Applicant Declaration carefully...
              </p>
              <div className="text-left mt-4 text-xs">
                <ApplicantDeclaration />
              </div>
              <div className="flex items-center mt-4">
                <input
                  type="checkbox"
                  id="terms-accepted"
                  checked={isApplicantTermsAccepted}
                  onChange={(e) => ApplicantAccepted(e.target.checked)}
                  className="mr-2"
                />
                <label htmlFor="terms-accepted" className="font-bold">
                  Accepted
                </label>
              </div>
            </div>
          )}
          <div className="text-center !mt-12">
            <button
              type="submit"
              className={`bg-blue-500 text-white px-6 py-2 rounded-lg ${
                !(
                  (isTermsAccepted && isMinorTermsAccepted) ||
                  (isTermsAccepted && isApplicantTermsAccepted)
                ) && "opacity-50 cursor-not-allowed"
              }`}
              disabled={
                !(
                  (isTermsAccepted && isMinorTermsAccepted) ||
                  (isTermsAccepted && isApplicantTermsAccepted)
                )
              }
            >
              Submit Application
            </button>
          </div>
        </form>
      </div>
    </body>
  );
};
